import { CreateService, CRUDServiceInterface } from '@/services/service';
import { WorkingReportEntity } from '@/entities/working-report.entity';

export default class WorkingReportService
  extends CreateService<WorkingReportEntity>('working-report')
  implements CRUDServiceInterface<WorkingReportEntity>
{
  async getWorkingTimeByMonth(
    monthAndYear: string,
  ): Promise<WorkingReportEntity[]> {
    const [month, year] = monthAndYear.split('/');
    this.apiBuilder.reset()
    const [data] = await this.apiBuilder
      .filter('month', '$eq', month)
      .filter('year', '$eq', year)
      .getMany();
    return data;
  }
}
